export const addresses = {
  dotNounsArt: "0x63BD0a939bDA16868Dfc976231F6a5943A3Fd6A0",
};
